import { global_hooks } from 'src/globals';
import { create_dom, create_div } from 'js/utils';

global_hooks.on('listing/init', init);
function init(listing) {
	init_render_results(listing);
	init_no_results(listing);

	listing.hooks.on('show_items', (items_to_show) => {
		show_items(items_to_show, listing);
	});
}

function init_render_results(listing) {
	let debounce;

	const render_result = async (result) => {
		await hide_all_items(listing.items, listing.args.transition_duration);

		listing.hooks.do('render_result/before', result);

		if (!result.length) {
			return;
		}

		const items_to_show = listing.hooks.apply_filter(
			'filter_results/items_to_show',
			result,
		);

		listing.hooks.do('show_items', items_to_show);
	};

	const render_result_debounce = (result) => {
		clearTimeout(debounce);
		debounce = setTimeout(() => render_result(result), 100);
	};

	listing.hooks.on('result/render', render_result_debounce);
}

function show_items(items_to_show, listing) {
	create_items_missing_html(items_to_show, listing);

	items_to_show.forEach((item) => {
		item.el.style.display = '';
	});

	setTimeout(() => {
		items_to_show.forEach((item) => {
			item.el.dataset.state = 'animate_in';
		});
	}, 10);
}

function hide_all_items(items, transition_duration) {
	const items_to_hide = items.filter((i) => i.el);

	return new Promise((resolve) => {
		items_to_hide.forEach((item) => {
			item.el.dataset.state = 'animate_out';
		});

		setTimeout(() => {
			items_to_hide.forEach((item) => {
				item.el.style.display = 'none';
			});
			resolve();
		}, transition_duration + 10);
	});
}

function create_items_missing_html(items, listing) {
	const items_no_html = items.filter((i) => i.html);
	if (!items_no_html.length) return;
	items_no_html.forEach((item) => {
		create_item_html(item, listing.container);
	});
}

function create_item_html(item, container) {
	const el = create_dom(item.html, container);
	delete item.html;
	el.style.display = 'none';
	el.dataset.state = 'animate_out';
	item.el = el;
}

function init_no_results(listing) {
	const msg = create_div('listings_no_result');
	listing.container.before(msg);
	msg.textContent = 'No results, please try different filters';
	msg.style.display = 'none';

	const update = (items_to_show) => {
		msg.style.display = items_to_show.length ? 'none' : '';
	};

	listing.hooks.on('render_result/before', update);
}
